<template >
      <outbox v-if="authenticated" :keycloak="keycloak"/>
</template>

<script>
import Outbox from "@/components/Outbox";

export default {
  props: ["authenticated", "keycloak"],
  components: {
    Outbox
  }
};
</script>
